import { createAction } from "@ngrx/store";
import { createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { SarRequestDatasetsResponse, SarRequestResponse, SarSubjectId } from "./personal-data.model";

const ACTION_PREFIX = "[Personal Data]";
export const PERSONAL_DATA_ACTION_TYPE = {
	getRequests: `${ACTION_PREFIX} Get Requests`,
	getRequestsSuccess: `${ACTION_PREFIX} Get Requests Success`,
	getRequestsFail: `${ACTION_PREFIX} Get Requests Fail`,
	requestDataSets: `${ACTION_PREFIX} Request Datasets`,
	requestDataSetsSuccess: `${ACTION_PREFIX} Request Datasets Success`,
	requestDataSetsFail: `${ACTION_PREFIX} Request Datasets Fail`,
	sendDownloadRequest: `${ACTION_PREFIX} Send Download Request`,
	sendDownloadRequestSuccess: `${ACTION_PREFIX} Send Download Request Success`,
	sendDownloadRequestFail: `${ACTION_PREFIX} Send Download Request Fail`,
	clear: `${ACTION_PREFIX} Clear`,
};
/**
 * @deprecated - [fabric-deprecated] - Use PersonalDataService from app-account mfe instead
 */
export namespace PersonalDataAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestSarData) instead
	 */
	export const getRequests = createAction(PERSONAL_DATA_ACTION_TYPE.getRequests);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestSarData) instead
	 */
	export const getRequestsSuccess = createGetSuccessAction(
		createAction(PERSONAL_DATA_ACTION_TYPE.getRequestsSuccess, (response: SarRequestResponse) => ({
			payload: response,
		}))
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestSarData) instead
	 */
	export const getRequestsFail = createAction(PERSONAL_DATA_ACTION_TYPE.getRequestsFail, (error: AppError) => ({
		error,
	}));
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	export const requestDataSets = createAction(
		PERSONAL_DATA_ACTION_TYPE.requestDataSets,
		(dataSets: SarSubjectId[]) => ({ payload: dataSets })
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	export const requestDataSetsSuccess = createGetSuccessAction(
		createAction(PERSONAL_DATA_ACTION_TYPE.requestDataSetsSuccess, (response: SarRequestDatasetsResponse) => ({
			response,
		}))
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	export const requestDataSetsFail = createAction(
		PERSONAL_DATA_ACTION_TYPE.requestDataSetsFail,
		(error: AppError) => ({ error })
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	export const sendDownloadRequest = createAction(PERSONAL_DATA_ACTION_TYPE.sendDownloadRequest, (id: string) => ({
		payload: id,
	}));
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	export const sendDownloadRequestSuccess = createGetSuccessAction(
		createAction(PERSONAL_DATA_ACTION_TYPE.sendDownloadRequestSuccess)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	export const sendDownloadRequestFail = createAction(
		PERSONAL_DATA_ACTION_TYPE.sendDownloadRequestFail,
		(error: AppError) => ({ error })
	);

	export const clear = createAction(PERSONAL_DATA_ACTION_TYPE.clear);
}
